import axios from 'axios';
import { permissions } from '@/constants';

const ADMINS = 'ADMINS';
const DEPARTMENTS = 'DEPARTMENTS';
const PROJECTS = 'PROJECTS';
const WORKERS = 'WORKERS';

export default {
  namespaced: true,
  state: () => ({
    admins: {},
    departments: {},
    projects: {},
    workers: {},
  }),
  actions: {
    async prefetch ({ dispatch }) {
      await Promise.all([
        dispatch('fetchAdmins'),
        dispatch('fetchDepartments'),
        dispatch('fetchProjects'),
        dispatch('fetchWorkers'),
      ]);
    },
    async fetchAdmins ({ commit, rootGetters }) {
      if (!rootGetters['auth/checkPermission'](permissions.ADMIN_READ)) {
        return;
      }

      const admins = await axios.get('/api/admin/');
      commit(ADMINS, admins.data.data);
    },
    async fetchDepartments ({ commit, rootGetters }) {
      if (!rootGetters['auth/checkPermission'](permissions.DEPARTMENT_READ)) {
        return;
      }

      const departments = await axios.get('/api/department/');
      commit(DEPARTMENTS, departments.data.data);
    },
    async fetchProjects ({ commit, rootGetters }) {
      if (!rootGetters['auth/checkPermission'](permissions.PROJECT_READ)) {
        return;
      }

      const projects = await axios.get('/api/project/');
      commit(PROJECTS, projects.data.data);
    },
    async fetchWorkers ({ commit, rootGetters }) {
      if (!rootGetters['auth/checkPermission'](permissions.WORKER_READ)) {
        return;
      }

      const workers = await axios.get('/api/worker/');
      commit(WORKERS, workers.data.data);
    },
  },
  mutations: {
    [ADMINS] (state, admins) {
      state.admins = admins.reduce((acc, d) => ({ ...acc, [d.id]: d }), {});
    },
    [DEPARTMENTS] (state, departments) {
      state.departments = departments
        .reduce((acc, d) => ({ ...acc, [d.id]: d }), {});
    },
    [PROJECTS] (state, projects) {
      state.projects = projects.reduce((acc, d) => ({ ...acc, [d.id]: d }), {});
    },
    [WORKERS] (state, workers) {
      state.workers = workers.reduce((acc, d) => ({ ...acc, [d.id]: d }), {});
    },
  },
};
